import React, { useState, useEffect } from "react";
import axios from 'axios';

import "./MenuBar.css";
import LogoHeader from "../LogoHeader";
import SearchBar from '../SearchBar';

import NotificationsIcon from '../../assets/images/notifications-icon.svg';
import UnreadNotificationsIcon from '../../assets/images/notifications-icon-unread.svg';

import { API_BASE_URL, DEFAULT_PROFILE_PICTURE } from "../../Variables";
import { getSocket } from "../../services/Socket";

function MenuBar({ handleNotificationsClick, handleProfileClick}) {
  const user = localStorage.getItem('user');
  const token = localStorage.getItem('token');
  const [imagePreview, setImagePreview] = useState(null);
  const [unreadNotificationsAvailable, setUnreadNotificationsAvailable] = useState(false);

  useEffect(() => {
    const socket = getSocket();
    if (socket) {
      socket.on('notification', (data) => {
        setUnreadNotificationsAvailable(true);
      });

      // Listen for the "noMoreUnreadNotifications" event
      socket.on(`noMoreUnreadNotifications`, (data) => {
        setUnreadNotificationsAvailable(false);
      });

      return () => {
        let parsedUser = JSON.parse(user);
        socket.off('notification');
        socket.off(`noMoreUnreadNotifications_${parsedUser.id}`);
      };
    }
  }, [user]);
  

  useEffect(() => {
    // Check if there are any unread notifications
    const checkUnreadNotifications = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/notifications/unread`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUnreadNotificationsAvailable(response.data.hasUnread);
      } catch (error) {
        console.error('Error fetching unread notifications:', error);
      }
    };
    checkUnreadNotifications();
  }, [token]);

  // Fetch the user's profile picture
  useEffect(() => {
    const fetchProfilePicture = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/profile-pictures`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          responseType: "blob",
        });
    
        const imageUrl = URL.createObjectURL(response.data);
        setImagePreview(imageUrl);
      } catch (error) {
        console.error("Error fetching profile picture:", error);
      }
    };
    let parsedUser = JSON.parse(user);
    if(parsedUser.profile_picture !== ""){
      fetchProfilePicture();
    }
  }, [user, token]);

  return (
    <div className="menu">
      <LogoHeader className={"menu-logo"}/>
      <SearchBar />
      <div className="menubar-dropdown-icons">
        <div className="menu-notifications">
          <img src={unreadNotificationsAvailable ? UnreadNotificationsIcon :  NotificationsIcon} alt="Notifications" className="notifications-icon" onClick={handleNotificationsClick}/>
        </div>
        <div className="menu-profile">
          <img src={imagePreview ? imagePreview : `${API_BASE_URL}${DEFAULT_PROFILE_PICTURE}`} alt="User Avatar" className="user-avatar profile-picture" onClick={handleProfileClick}/>
        </div>
      </div>
      
    </div>
  );
}

export default MenuBar;